<template>
  <ModalBase @close-modal="close" show-modal narrow auto-h>
    <template v-slot:titlebar>
      <div class="answer-list-wrap">
        <h4>Answers</h4>
         <ul :key="answerkey" class="answer-list">
          <li v-for="(answer, index) in compAnswers" :key="'answer-' + index">
            <small>{{ answer.id }}</small>: {{ answer.question }} -> {{ answer.value }}
          </li>
        </ul>
      </div>
    </template>
    <template v-slot:maincontent>
      <h3 v-if="currentStep.type === 'question'">Step {{ (currentStepIdx + 1) }}</h3>
      <SurveyStep @next-step="nextStep()" @prev-step="prevStep()" @save-answer="saveAnswer" :step-data="currentStep" :key="currentStepIdx" />
    </template>

    <template v-slot:actions>
      <hr>
      <div class="survey-modal-footer">
        <GekkoButton
          @click="close"
          :text="$gettext('Cancel')" 
          variant="link"
          class="text-danger"
        />
        <div><small>Step {{ (currentStepIdx + 1) }} of {{ steps.length }}</small></div>
        <GekkoButton
          @click="submit"
          :text="$gettext('Generate report')" 
          :disabled="!isComplete"
          icon="fa-solid fa-chart-column"
          class="generate-report-btn"
        />
      </div>
    </template>

  </ModalBase>
</template>

<script>
import SurveyStep from "@/components/ui/survey/SurveyStep"

import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"
import CostService from "@/store/services/cost.service";
import TripService from "@/store/services/trip.service";
import ReportsService from "@/store/services/reports.service";
import CompanyService from "@/store/services/company.service";
import {mapGetters} from "vuex";

export default {
  name: 'SurveyModal',
  components: {
    ModalBase, TitleBar, GekkoButton, SurveyStep
  },
  data () {
    return {
      currentStepIdx: 0,
      answers: [],
      answerkey: 0,
      km_total: 0,
      km_private: 0,
      car_costs: 0,
      reverse_charge_total: 0,
      reverse_charge_total_count: 0,
      steps: [
        {
          type: "question",
          id: 'treat_non_dutch_as_dutch',
          question: {
            text: ""
          }
        },
      ],
    }
  },
  computed: {
    currentStep () {
      return this.steps[this.currentStepIdx]
    },
    compAnswers () {
      return Object.values(this.answers)
    },
    isComplete () {
      return (this.currentStepIdx + 1) === this.steps.length
    },
    ...mapGetters({
      reportInitialValues: "taxreports/getReportInitialValues",
      currentCompany: "main/getCurrentCompany",
    })
  },
  mounted () {
    document.body.classList.add('modal-on');
  },
  created() {
    var params = {
        company_profile:this.currentCompany.id,
        year: this.reportInitialValues.year,
        owner_company:this.currentCompany.id,
        start_date:this.reportInitialValues.year + "-01-01",
        end_date:this.reportInitialValues.year + "-12-31",
        transport_type: 'car'
    };
    let km_total = TripService.getTotalKmBusiness(params);
    let km_private = TripService.getTotalKmPrivate(params);
    params = {
        owner_company:window.company_id,
        cost_type__default_name: 'car',
        start_date:this.reportInitialValues.year + "-01-01",
        end_date:this.reportInitialValues.year + "-12-31",
        transport_type: 'car'
    };
    let car_costs = CostService.totalNet(params);
    params = {
      owner_company: window.company_id,
      // start_date:startEndDate.start_date,
      // end_date:startEndDate.end_date,
      tax_exempt:false,
      tax_exists: false
    };
    let reverse_charge_total = CostService.total(params);
    let reverse_charge_total_count = CostService.count(params);
    Promise.all([
        km_total,
        km_private,
        car_costs,
        reverse_charge_total,
        reverse_charge_total_count,
    ]).then((responses) => {
      this.km_total = responses[0].data;
      this.km_private = responses[1].data;
      this.car_costs = Math.floor(responses[2].data);
      this.reverse_charge_total = Math.floor(responses[3].data);
      this.reverse_charge_total_count = this.$gettext("divided over %[i] entries.").replace('%[i]', responses[4].data);
      this.initSteps();
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit (){
      this.$emit('submit', Object.values(this.answers));
    },
    nextStep () {
      if (this.currentStepIdx < (this.steps.length - 1)) this.currentStepIdx++
    },
    prevStep () {
      if (this.currentStepIdx > 0) this.currentStepIdx--
    },
    saveAnswer (option) {
      const new_answer = {
        id: option.id,
        question: option.text,
        value: option.value
      }
      this.$set(this.answers, option.id, new_answer)
    },
    initSteps(){
      this.steps = [
          {
              type: 'question',
              id: 'treat_non_dutch_as_dutch',
              question: {
                  text: this.$gettext('Do you want to declare VAT from non-Dutch customers to the Belastingdienst?'),
                  short_text: 'Treat Non Dutch customers as Dutch',
                  type: 'choose-one',
                  options: [
                      { text: 'Yes', value: 'true', fn: { name: 'nextStep' } },
                      { text: 'No', value: 'false', fn: { name: 'nextStep' } },
                  ]
              }
          },
          {
              type: 'question',
              id: 'import_without_vat',
              question: {
                  text: this.$gettext('Do you have any goods or services being imported from abroad for which you paid no VAT?'),
                  short_text: 'Goods/services imported?',
                  type: 'choose-one',
                  options: [
                      {
                          text: 'Yes',
                          value: 'true',
                          fn: {
                              name: 'loadSubstep',
                              params: {
                                  component: {
                                      name: 'GoodsImported',
                                      data: {
                                        reverse_charge_total: this.reverse_charge_total,
                                        reverse_charge_total_count: this.reverse_charge_total_count
                                      }
                                  }
                              }
                          }
                      },
                      { text: 'No', value: 'false', fn: { name: 'nextStep' } },
                  ]
              }
          },
          {
              type: 'question',
              id: 'over_gift_limit',
              question: {
                  text: this.$gettext('Did you give more than 227 EUR (ex VAT) in representational gifts to a single person in one year?'),
                  short_text: 'Gifts exceed €227?',
                  type: 'choose-one',
                  options: [
                      {
                          text: 'Yes',
                          value: 'true',
                          fn: {
                              name: 'loadSubstep',
                              params: {
                                  component: {
                                      name: 'GiftsExceed'
                                  }
                              }
                          }
                      },
                      { text: 'No', value: 'false', fn: { name: 'nextStep' } },
                  ]
              }
          },
          {
              type: 'message',
              nextbutton: 'I Understand',
              question: {
                  text: this.$gettext('Important notice: the kleine ondernemersregeling is no longer applicable in 2020 if you pay VAT. If you are part of the new kleine ondernemingsregeling you do not have to report VAT to the Belastingdienst. Please check with the Belastingdienst whether this rule applies to you.'),
              }
          },
          {
              type: 'question',
              id: 'private_car_costs',
              question: {
                  text: this.$gettext('Would you like to adjust the VAT amount in car costs to reflect private use?'),
                  short_text: 'Private use of car?',
                  type: 'choose-one',
                  options: [
                      {
                          text: 'Yes',
                          value: 'true',
                          fn: {
                              name: 'loadSubstep',
                              params: {
                                  component: {
                                      name: 'PrivateCarCosts',
                                      data: {
                                        km_business: this.km_total - this.km_private,
                                        km_private: this.km_private,
                                        km_total: this.km_total,
                                        car_costs: this.car_costs
                                      }
                                  }
                              }
                          }
                      },
                      { text: 'No', value: 'false', fn: { name: 'nextStep' } },
                  ]
              }
          },
          {
              type: 'question',
              id: 'private_expenses',
              question: {
                  text: this.$gettext('Do you have any private expenses?'),
                  short_text: 'Private expenses?',
                  type: 'choose-one',
                  options: [
                      {
                          text: 'Yes',
                          value: 'true',
                          fn: {
                              name: 'loadSubstep',
                              params: {
                                  component: {
                                      name: 'PrivateExpenses'
                                  }
                              }
                          }
                      },
                      { text: 'No', value: 'false', fn: { name: 'nextStep' } },
                  ]
              }
          },
          {
              type: 'message',
              question: {
                  text: this.$gettext('A correction report will also be calculated. Corrections include any data that has not been reflected in previous reports.'),
              }
          },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .survey-modal-footer {
    display: flex; 
    justify-content: space-between; 
    align-items: center;
  }
  .answer-list-wrap {
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .answer-list {
      list-style: none; margin: 0; padding: 0;
    }
  }
  .generate-report-btn {
    &.disabled {
      opacity: 0.3 !important;
      filter: grayscale(1);
    }
  }
</style>
